import { Loader2 } from "lucide-react";
import { type ReactElement } from "react";

// Mirrors LoginPage's shell so the visual handoff after the auth check
// resolves is seamless. Used while AuthProvider is determining whether
// the user has a session — Cognito cold starts can take several seconds
// and a blank page reads as broken.
export function LoadingScreen(): ReactElement {
  return (
    <div
      data-testid="auth-loading-screen"
      className="flex min-h-screen items-center justify-center bg-background p-6"
    >
      <div className="w-full max-w-sm space-y-6">
        <div className="space-y-2 text-center">
          <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded bg-[#C2785C]">
            <span className="text-lg font-bold text-white">E</span>
          </div>
          <h1 className="text-2xl font-semibold tracking-tight">Endure Ops Console</h1>
          <p
            role="status"
            aria-live="polite"
            className="flex items-center justify-center gap-2 text-sm text-muted-foreground"
          >
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
            Loading…
          </p>
        </div>
      </div>
    </div>
  );
}
